<template>
  <validation-provider
    #default="{ errors }"
    :vid="name"
    :name="formatName(name)"
    :rules="rules"
  >
    <b-form-group>
      <label
        v-if="label"
        :for="name"
      >{{ label }}<b
        v-if="isRequired"
        class="text-danger"
        style="font-size: 15px"
      >*</b></label>
      <b-form-textarea
        :id="name"
        :placeholder="placeholder"
        :rows="rows"
        :no-resize="!resize"
        :value="value"
        @input="inputChanged"
      />
      <small class="text-danger text-capitalize">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
/* eslint-disable global-require */
import { ValidationProvider } from 'vee-validate'
import { required, email } from '@core/utils/validations/validations'

export default {
  name: 'LenonTextArea',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  props: {
    name: {
      type: String,
      default: 'input',
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    resize: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: String,
      default: '3',
    },
    rules: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      required,
      email,
    }
  },
  computed: {
    isRequired() {
      return this.rules.includes('required')
    },
  },
  methods: {
    formatName(name) {
      return name.replaceAll('_', ' ')
    },
    suffixIconClicked(e) {
      this.$emit('onSuffixIconClick', e)
    },
    prefixIconClicked(e) {
      this.$emit('onPrefixIconClick', e)
    },
    enterPressed(e) {
      this.$emit('onEnterPressed', e)
    },
    inputChanged(e) {
      this.$emit('input', e)
    },
  },
}
</script>

<style scoped>

</style>
